<template>
  <div id="app">
    <the-header />
    <loading v-show="isLoading" />
    <div class="container max-w-full">
      <router-view/>
    </div>
    <the-footer />
  </div>
</template>

<script>
import store from './store';
import { mapGetters } from 'vuex'
import './assets/common.css'
import './assets/stylesheets/main.scss'
import './assets/menu.scss'

import TheHeader from './components/organisms/TheHeader.vue'
import TheFooter from './components/organisms/TheFooter'
import Loading from './components/organisms/Loading.vue'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    Loading
  },
  computed: {
    ...mapGetters({
      isLoading: 'loading/isLoading'
    }),
  },
  created () {
    if (this.$route.params.lang) {
      store.dispatch('user/setLang', this.$route.params.lang)
    } else {
      store.dispatch('user/setLang', 'ja')
    }
  },
  methods : {
    createTitleDesc : function(){
      // タイトルを設定
      document.title = 'HAWAII MaaS'
    }
  },
  mounted : function(){
      this.createTitleDesc();
  }
}
</script>
